module.exports = __webpack_public_path__ + "img/3@3x.c9b17a4a.png";